"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useAppContext } from "@/app/contextProviders/app-context";
import { StepConnector } from "./StepConnector";
import { StepIndicator } from "./StepIndicator";
interface StepItemProps {
  label: string;
  stepNumber: number;
  isActive: boolean;
  isCompleted: boolean;
  isFuture: boolean;
  isLast: boolean;
  stepDataFields?: string;
  isAppointmentReviewStep?: boolean;
  isConfirmationStep?: boolean;
  onNavigate: () => void;
  /** When true, keep the "completed" visual but suppress the button/click affordance. */
  disableNavigation?: boolean;
  /** Only used on mobile — renders step content inline when active */
  children?: React.ReactNode;
}
export function StepItem(t0) {
  const $ = _c(55);
  const {
    label,
    stepNumber,
    isActive,
    isCompleted,
    isFuture,
    isLast,
    stepDataFields,
    isAppointmentReviewStep,
    isConfirmationStep,
    onNavigate,
    disableNavigation,
    children
  } = t0;
  const theme = useTheme();
  const {
    deviceType
  } = useAppContext();
  let t1;
  if ($[0] !== theme.breakpoints) {
    t1 = theme.breakpoints.down("sm");
    $[0] = theme.breakpoints;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = deviceType === "mobile";
  let t3;
  if ($[2] !== t2) {
    t3 = {
      defaultMatches: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const isSmallScreen = useMediaQuery(t1, t3);
  const showConnector = !isLast && (isSmallScreen ? !isActive : true);
  const t4 = isCompleted ? "10px" : "0";
  let t5;
  if ($[4] !== t4) {
    t5 = {
      paddingTop: t4
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isActive || $[7] !== isCompleted || $[8] !== isFuture || $[9] !== stepNumber) {
    t6 = <StepIndicator stepNumber={stepNumber} isActive={isActive} isCompleted={isCompleted} isFuture={isFuture} />;
    $[6] = isActive;
    $[7] = isCompleted;
    $[8] = isFuture;
    $[9] = stepNumber;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isCompleted || $[12] !== showConnector) {
    t7 = showConnector && <StepConnector isCompleted={isCompleted} />;
    $[11] = isCompleted;
    $[12] = showConnector;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <Box sx={t5}>{t6}{t7}</Box>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const indicator = t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      display: "flex",
      flexDirection: "column",
      minWidth: 0
    };
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = isCompleted && !isAppointmentReviewStep && !isConfirmationStep ? "bodyXS" : "bodyS";
  const t11 = (isAppointmentReviewStep || isConfirmationStep) && isCompleted ? "14px" : "5px";
  const t12 = isFuture ? theme.palette.text.disabled : theme.palette.text.secondary;
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = {
      marginTop: t11,
      color: t12
    };
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== label || $[23] !== t10 || $[24] !== t13) {
    t14 = <Typography variant={t10} sx={t13}>{label}</Typography>;
    $[22] = label;
    $[23] = t10;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== isAppointmentReviewStep || $[27] !== isCompleted || $[28] !== isConfirmationStep || $[29] !== stepDataFields || $[30] !== theme.palette.text.secondary) {
    t15 = isCompleted && !isAppointmentReviewStep && !isConfirmationStep && <Typography variant="bodyS" sx={{
      overflowWrap: "anywhere",
      color: theme.palette.text.secondary
    }}>{stepDataFields}</Typography>;
    $[26] = isAppointmentReviewStep;
    $[27] = isCompleted;
    $[28] = isConfirmationStep;
    $[29] = stepDataFields;
    $[30] = theme.palette.text.secondary;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14 || $[33] !== t15) {
    t16 = <Box sx={t9}>{t14}{t15}</Box>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const labelContent = t16;
  let t17;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      xs: "20px",
      md: "0"
    };
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const t18 = isCompleted ? "-12px" : "0";
  let t19;
  if ($[36] !== t18) {
    t19 = {
      display: "flex",
      gap: "12px",
      paddingLeft: t17,
      marginTop: t18
    };
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== disableNavigation || $[39] !== indicator || $[40] !== isCompleted || $[41] !== label || $[42] !== labelContent || $[43] !== onNavigate) {
    t20 = isCompleted && !disableNavigation ? <Box component="button" onClick={onNavigate} aria-label={`Edit ${label}`} sx={{
      display: "flex",
      gap: "12px",
      cursor: "pointer",
      background: "none",
      border: "none",
      padding: 0,
      textAlign: "left",
      font: "inherit",
      color: "inherit"
    }}>{indicator}{labelContent}</Box> : <>{indicator}{labelContent}</>;
    $[38] = disableNavigation;
    $[39] = indicator;
    $[40] = isCompleted;
    $[41] = label;
    $[42] = labelContent;
    $[43] = onNavigate;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t19 || $[46] !== t20) {
    t21 = <Box sx={t19}>{t20}</Box>;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== children || $[49] !== isActive || $[50] !== isSmallScreen) {
    t22 = isSmallScreen && isActive && <Box>{children}</Box>;
    $[48] = children;
    $[49] = isActive;
    $[50] = isSmallScreen;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t21 || $[53] !== t22) {
    t23 = <Box>{t21}{t22}</Box>;
    $[52] = t21;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  return t23;
}